export default __webpack_public_path__ + "static/media/M-Mafo.0e2afac7.jpg";